import StyleLayer from '../style_layer';
import properties from './background_style_layer_properties';
class BackgroundStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties);
    }
}
export default BackgroundStyleLayer;
//# sourceMappingURL=background_style_layer.js.map